<template>
	<div id="searchBox">
		<!-- 公共form表单样式 -->
		<div class="form-item-public">	
			<el-form label-width="69px" inline label-position="right" :model="form">
				<h2>期间</h2>
				<el-form-item label="">
					<accounting-period ref="accountingPeriod" @defaultTime='defaultTime'></accounting-period>
				</el-form-item>
				<h2>凭证属性</h2>
				<el-form-item label="凭证字">
					<el-select size="small" style="width: 90px;" v-model='form.certificateWordId' clearable>
						<el-option v-for='i in VoucherWord' :label="i.certificateWord" :value="i.id" :key='i.id'></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="凭证号">
					<el-input size="small" style="width: 94px;" v-model='form.startNumber' placeholder='开始' ref='startNumbers'></el-input><span class="mid">至</span>
					<el-input size="small" style="width: 94px;" v-model='form.endNumber' placeholder='结束'></el-input>
				</el-form-item>
				<h2>分录属性</h2>
				<el-form-item label="摘要">
					<el-input size="small" placeholder="请输入摘要" style="width: 247px;" v-model='form.summary'></el-input>
				</el-form-item>
				<el-form-item label="科目">
					<el-select
						size="small"
						style="width: 247px;"
						placeholder="请选择"
						v-model="form.subjectId" filterable clearable>
					    <el-option
					    	v-for="item in subjectData"
					    	:key="item.id"
					    	:label="item.labels"
					    	:value="item.id">
					    </el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="辅助核算">
					<el-select size="small" style="width: 94px;" v-model="form.auxiliaryAccountingType" @change='handleAuxiliaryChange' 	  			clearable>
						<el-option v-for='i in allAccounting' :label="i.name" :value="i.id" :key='i.id'></el-option>
					</el-select>
					<el-select size="small" style="width: 150px;" v-model="form.auxiliaryAccountingId" clearable>
						<el-option v-for='i in allAccountingID' :label="i.name" :value="i.id" :key='i.id'></el-option>
					</el-select>
				</el-form-item>
				<h2>其他</h2>
				<el-form-item label="金额">
					<el-select size="small" style="width: 94px;" v-model='form.foreignCurrencyId' clearable>
						<el-option v-for='i in foreignCurrencyList' :label="i.name" :value="i.id" :key='i.id'></el-option>
					</el-select>
					<el-input size="small" style="width: 55px;" v-model='form.startMoney' placeholder='始' ref='startMoneys'></el-input><span class="mids">至</span>
					<el-input size="small" style="width: 55px;" v-model='form.endMoney' placeholder='终'></el-input>
				</el-form-item>
        <el-form-item label="数量凭证">
					<el-select size="small" style="width: 247px;" v-model='form.amout' clearable>
						<el-option v-for='i in numberList' :label="i.name" :value="i.id" :key='i.id'></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="制单人">
					<el-input size="small" placeholder="请输入制单人" style="width: 247px;" v-model='form.singlePerson'></el-input>
				</el-form-item>
				<el-form-item label="标记">
						<el-select size="small" style="width: 94px;" v-model='form.signId' >
							<el-option v-for='i in dropDownList' :label="i.name" :value="i.id" :key='i.id'></el-option>
						</el-select>
						<el-input v-model='form.signReason' size="small" style="width: 150px;" placeholder="请输入标记原因"></el-input>
				</el-form-item>
				<el-form-item class="btn-align">
					<el-button size="small" @click='Reset' class='secondaryButton'>重置</el-button>
					<el-button class='minButton' size="small" @click='handleSearch'>搜索</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	import accountingPeriod from '@/components/dialog/accountingPeriod'
	export default{
		components: {
			accountingPeriod
		},
		data(){
			return {
				firstGet: true,   // 请求一次
        numberList: [
          {
            name: "全部",
            id: "1"
          },
          {
            name: "数量核算凭证",
            id: "2"
          },
          {
            name: "非数量核算凭证",
            id: "3"
          }
        ],
				form: {
					auxiliaryAccountingType:　'', // 辅助核算类别
					startYearPeriods: '', // 开始的年和期数
					endYearPeriods:'',  // 结束的年和期数
					certificateWordId: '',  // 凭证字
					startNumber: '',  // 开始的凭证编号
					endNumber: '',  // 结束的凭证编号
					summary: '',    // 摘要
					startMoney: '',  // 开始金额
					endMoney: '',   // 结束金额
					singlePerson: '',  // 制单人
					subjectId: '',    // 科目ID
					auxiliaryAccountingId: '',  // 辅助核算
					foreignCurrencyId: '',  // 外币ID
					signId:0,  // 标记颜色
					signReason:"",  // 标记原因
          amout: "1", // 数量凭证
				},
				VoucherWord: [],   // 凭证字
				allAccounting: [],  // 辅助核算类别
				allAccountingID: [],  // 辅助核算摘要
				foreignCurrencyList: [],  // 外币核算
				dropDownList:[],    // 标记选项
			}
		},
		created() {
			this.getVoucherWord();
			this.getAllSubject();
			this.findAllOject();
			this.getForeignCurrency();
			this.getDropDown();
		},
		mounted() {
			
		},
    watch: {
      '$route': {
        handler(to,from) {
          const { date } = this.$route.query
          if(from.path == '/examine' && !this.firstGet && date) {
            this.form.startYearPeriods = date
            this.form.endYearPeriods = date
            const str = date.slice(0,4)+'年'+date.slice(4,6)+'期'
            let _date = date.slice(0,4)+'-'+date.slice(4,6)
            this.$refs.accountingPeriod.setYearPeriodsStart(_date,_date)
            this.$emit('defaultDate' ,str + '-' + str);
            this.$emit('formMessage' , this.form);

          }else {
            this.Reset()
          }
        },
        deep: true, // 深度观察监听 设置为 true
      }
    },
		computed: {
			// 科目
			subjectData() {
				return this.$store.state.getSubjectId.AllSubjectList
			}
		},
		methods:{
			// 获取查询凭证的标记下拉选项
			getDropDown() {
				this.$http.post('voucherChief/getDropDown',{}).then(res=>{
					if(res.data&&res.data.code) {
						this.dropDownList = res.data.data;
					}
				})
			},
			// 根据辅助核算类别获取摘要
			handleAuxiliaryChange(val) {
				if(val) {
					this.$http.post('auxiliaryAccounting/list',{id: val}).then(res=>{
						this.allAccountingID = res.data.data.list;
						this.form.auxiliaryAccountingId = res.data.data.list[0].id;
					})
				}else {
					this.form.auxiliaryAccountingId = '';
					this.allAccountingID = [];
				}
				
			},
			// 搜索
			handleSearch(){
				if((!Number(this.form.startNumber)&&this.form.startNumber!='')||(!Number(this.form.endNumber)&&this.form.endNumber!='')||(!Number(this.form.startMoney)&&this.form.startMoney!='')||(!Number(this.form.endMoney)&&this.form.endMoney!='')) {
					return this.$message.warning('系统检测到凭证号或金额有非数字输入，请您确认后操作！')
				}
				if(Number(this.form.startNumber)>Number(this.form.endNumber)) {
					this.$refs.startNumbers.focus();
					this.$refs.startNumbers.select();
					return this.$message.warning('凭证号开始应该小于或等于凭证号结束哦！')
				}
				if(Number(this.form.startMoney)>Number(this.form.endMoney)) {
					this.$refs.startMoneys.focus();
					this.$refs.startMoneys.select();
					return this.$message.warning('金额开始应该小于或等于金额结束哦！')
				}
				this.$emit('formMessage' , this.form);
				this.$emit('sendFalseMessage' , false);
			},
			// 查询所有科目
			getAllSubject () {
				
				this.$store.dispatch('getAllSubject')
				
			},
			// 接收会计期间数据
			defaultTime(data) {
				let rangeStartYearPeriods = this.$util.formatDate.format(data.yearPeriodsStart , 'yyyy年MM期');
				let rangeEndYearPeriods = this.$util.formatDate.format(data.yearPeriodsEnd , 'yyyy年MM期');
				this.form = Object.assign(this.form,{
					startYearPeriods: this.$util.formatDate.format(data.yearPeriodsStart , 'yyyyMM'),
					endYearPeriods:  this.$util.formatDate.format(data.yearPeriodsEnd , 'yyyyMM'),
				});
				let startData = rangeStartYearPeriods ? rangeStartYearPeriods+' - ' : '';
				let endData = rangeEndYearPeriods ? rangeEndYearPeriods : '';
				this.$emit('defaultDate' ,startData+endData);
        console.log(this.firstGet)
				if(this.firstGet ) {
          const { date } = this.$route.query
          // 这是跳转带参情况
          if(date) {
            this.form.startYearPeriods = date
            this.form.endYearPeriods = date
            const str = date.slice(0,4)+'年'+date.slice(4,6)+'期'
            this.$emit('defaultDate' ,str + '-' + str);
          }
					this.$emit('formMessage' , this.form);
					this.firstGet = false;
				}
				
			},
			// 获取凭证字
			getVoucherWord() {
				this.$http.post('voucherWord/list',{}).then(res=>{
					if(res) {
						this.VoucherWord = res.data.data;
						this.$emit('VoucherWord' , res.data.data);
					}
				})
			},
			//查询辅助类别
			findAllOject(){
				const _=this;
				let datas = {
				}
				_.$http.post('auxiliaryAccounting/allAccounting',datas).then((res)=>{
					if(res && res.data.code == '1'){
						this.allAccounting = res.data.data;
					}
				})
			},
			// 获取外币核算
			getForeignCurrency(){
				const _=this;
				_.$http.post('foreignCurrency/findAll',{}).then((res)=>{
					if(res && res.data.code == '1'){
						let list =  res.data.data;
						this.foreignCurrencyList = list;
						// for(let i=0;i<list.length;i++){
						// 	if(list[i].standard){
						// 		this.form.foreignCurrencyId = list[i].id;
						// 	}
						// }
					}
				})
			},
			// 重置
			Reset() {
				this.form = Object.assign(this.form,{
					certificateWordId: '',  // 凭证字
					startNumber: '',  // 开始的凭证编号
					endNumber: '',  // 结束的凭证编号
					summary: '',    // 摘要
					startMoney: '',  // 开始金额
					auxiliaryAccountingType: '',
					endMoney: '',   // 结束金额
					singlePerson: '',  // 制单人
					subjectId: '',    // 科目ID
					auxiliaryAccountingId: '',  // 辅助核算
					foreignCurrencyId: '',  // 外币ID
					signId:0,  // 标记颜色
					signReason:"",  // 标记原因
          amout: "1", // 数量凭证
				})

				this.$emit('formMessage' , this.form);
			},

		},
	}
</script>

<style lang="less">
	#searchBox{
		width: 328px;
		background-color: #fff;
		border-radius:0 0 4px 4px;
		padding:0 20px 20px;
		border:solid 1px #eee; 
		.el-form-item {
			padding: 2px 0;
			position: relative;
		}
		.mid{
			padding:0 15px;
		}
		.mids{
			padding:0 10px;
		}
		.el-form--label-right{
			.el-form-item__label{
				text-align: right;
			}
		}
		h2{
			font-size: 14px;
			line-height: 1;
			margin:20px 0 10px 0;
		}
		.btn-align{
			width:100%;
			text-align: center;
			margin-top: 30px;
			.el-form-item__content{
				width: 100%;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/dialog/searchBox.vue